import { render } from "./MemberWelcome.vue?vue&type=template&id=4fed969f&scoped=true"
import script from "./MemberWelcome.vue?vue&type=script&lang=js"
export * from "./MemberWelcome.vue?vue&type=script&lang=js"

import "./MemberWelcome.vue?vue&type=style&index=0&id=4fed969f&scoped=true&lang=css"

import exportComponent from "/var/www/html/pavithram.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fed969f"]])

export default __exports__